import { ModuleWithProviders, NgModule } from '@angular/core';

import { TOASTR_CONFIG, ToastrConfig, ToastrService } from './toastr.service';

@NgModule()
export class ToastrModule {
	static forRoot(config: ToastrConfig = {}): ModuleWithProviders<ToastrModule> {
		return {
			ngModule: ToastrModule,
			providers: [ToastrService, { provide: TOASTR_CONFIG, useValue: config }],
		};
	}
}
